import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'errorMessage'
})
export class ErrorMessagePipe implements PipeTransform {

  transform(value: any, ...args: unknown[]): unknown {
    if (value.min) {
      return `Value too small. Minimal allowed value is ${value.min.min}`
    }
    if (value.max) {
      return `Value too big. Maximal allowed value is ${value.max.max}`
    }
    if (value.pattern) {
      return 'Value contains invalid character(s)'
    }
    return null;
  }

}
